import { render } from "./Billing.vue?vue&type=template&id=f0aba2ca&ts=true"
import script from "./Billing.vue?vue&type=script&lang=ts"
export * from "./Billing.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__